export enum PixelEventsTypes {
  CompleteRegistration = "Complete Registration",
  Lead = "Lead",
  ViewContent = "View Content",
  Subscribe = "Subscribe",
  InitiateCheckout = "Initiate Checkout",
  StartTrial = "Start Trial",
  SubmitApplication = "Submit Application",
}
